/* jshint -W024 */
const LoginRoutes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/ui/views/public/login/login.vue')
  },
  {
    path: '/login/not-available',
    name: 'not-available',
    component: () => import('@/ui/views/public/login/NotAvailable.vue')
  },
  {
    path: '/login/email-change',
    name: 'email-change',
    component: () => import('@/ui/views/public/login/EmailChange.vue')
  },
  {
    path: '/login/reset-password',
    name: 'reset-password',
    component: () => import('@/ui/views/public/login/ResetPassword.vue')
  },
  {
    path: '/login/restore-password',
    name: 'restore-password',
    component: () => import('@/ui/views/public/login/RestorePassword.vue')
  }
];

export default LoginRoutes;
